import React from 'react';
import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


function CopyButtonRenderer(props) {
  const { label, uischema, handleChange } = props;
  const ctx = useJsonForms();

  const handleClick = () => {
    uischema.copy.forEach(element => {
      handleChange(element.to, ctx.core.data[element.from]);
    });
  };

  return (
    <Button variant="contained" component="label" endIcon={<ContentCopyIcon />} onClick={handleClick} sx={{ mb: 2 }}>
      {label}
    </Button>

  );
}

export default withJsonFormsControlProps(CopyButtonRenderer);


export const CopyButtonTester = rankWith(1000, uiTypeIs('CopyButton'));
